import { render, staticRenderFns } from "./GloboplayVideoPlayer.vue?vue&type=template&id=8abc24de&scoped=true&"
import script from "./GloboplayVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./GloboplayVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./GloboplayVideoPlayer.vue?vue&type=style&index=0&id=8abc24de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abc24de",
  null
  
)

export default component.exports